import { userActiveStep } from 'utils/constants/account/user-status';

export const BUTTON_TEXT_MAPPING = {
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_0]:
    'account.KYCDataProcessingButtonText',
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_5]:
    'account.KYCClientActionButtonText'
};

export const MESSAGE_MAPPING = {
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_0]:
    'account.KYCDataProcessingMessage',
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_3]:
    'account.KYCVerificationFailedMessage',
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_4]:
    'account.KYCVerificationExpiredMessage',
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_5]:
    'account.KYCClientActionMessage',
  [userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_7]:
    'account.KYCProviderWaitingMessage'
};

export const USER_ACTIVE_STEP_STATES_TO_SHOW_STATUS_BAR = Object.keys(
  MESSAGE_MAPPING
).map(k => +k);
